// React imports.
import React from "react";

import { Assessment1StepsEnum } from "../state";
import { Assessment1FuelStatusEnum } from "../state";
import Assessment1QuestionsUnderReporting from "./Assessment1QuestionsUnderReporting";
import Assessment1QuestionsOverReporting from "./Assessment1QuestionsOverReporting";

const Assessment1Questions = ({fuelType, state }) => (
    <div>
        {/*InRangeNoIssues*/}
        {(fuelType.percentOfSedsStatus == Assessment1FuelStatusEnum.InRangeNoIssues
            &&fuelType.viewAnyway != true)
          &&<p>
                <br/>
                The electric baseload expenditures for   {fuelType.description}   households  
                from your Performance Data Form are not out of range. No  
                further action is required for   {fuelType.description}   households  
                in Assessment #1. If you want to analyze potential data  
                reliability issues for   {fuelType.description}   households  
                anyway click &nbsp;
                <button className="dataButton"
                    onClick={(changeEvent) => state.assessment1ViewAnyway(changeEvent, fuelType)}>
                    here
                </button>.&nbsp;   Otherwise, click Next to continue.
            </p>
        }
        {/*No ACS and no households*/}
        {(fuelType.percentOfSedsStatus == Assessment1FuelStatusEnum.NoSEDSData)
        &&<span>
              
          </span>
        }
        {/*No ACS and but households*/}
        {(fuelType.percentOfSedsStatus != Assessment1FuelStatusEnum.NoSEDSData
            && fuelType.computedAverageExpenditure === 0
            && fuelType.totalAssistedhHNum>0)
          &&
            <div>
                <strong>Requires followup.</strong>&nbsp; 
                Your data will be more reliable and complete if you are able to collect
                and report complete electric expenditures for&nbsp;{fuelType.description}&nbsp; households.
                In the box below please describe the reasons you are unable to collect
                electric baseload data for &nbsp;{fuelType.description}&nbsp; households
                and any actions you can take to address this issue.
                <br/><br/>
                Please indicate your plans to address this issue in the box below
                <textarea  name="ZeroAvgExpenditureDataReasonDesc"
                    id="ZeroAvgExpenditureDataReasonDesc" style={{width:"100%"}}
                    value={fuelType.ZeroAvgExpenditureDataReasonDesc}
                    onChange={(changeEvent) => state.assessment1FieldChangeHandler(changeEvent, fuelType)}></textarea>
            </div> 
        }

        {/*UnderMin*/}
        {(fuelType.percentOfSedsStatus === Assessment1FuelStatusEnum.UnderMin)
            &&
            <div>
                <br/>
                Since the reported average electric baseload expenditures for
                your  {fuelType.description}  households are less than expected, let's explore
                some reasons why you might have that result.
                <br/><br/>
                <Assessment1QuestionsUnderReporting state={state}  fuelType={fuelType} showDontKnowNote={true}/>
                {
                  (fuelType.IncludingEnergyUseChargesFlag !== null
                    && fuelType.IncludingEnergyDeliveryChargesFlag !== null
                    && fuelType.IncludeSupplierChargesFlag !== null
                    && fuelType.IncludingComplete12MonthFlag !== null
                    && fuelType.IndicatingLessThan12MonthFlag !== null
                    && fuelType.ReportingAfterDiscountsFlag !== null)
                  &&
                    <div>
                        Now that you have checked for reasons that the average expenditures might be too low it is useful to check
                        ways in which vendors might be over-reporting for some clients. Here are some important issues.
                        <br/><br/>

                        <Assessment1QuestionsOverReporting state={state}  fuelType={fuelType}  showDontKnowNote={false}/>
                    </div>
                }
            </div>
        }        


        {/*InRangeNoIssues, viewAnyway, averageExpenseLessThanSeds*/}
        {(fuelType.percentOfSedsStatus === Assessment1FuelStatusEnum.InRangeNoIssues
            && fuelType.viewAnyway === true
            && fuelType.averageExpenseGreaterThanSeds === false)
            &&
            <div>
                <br/>
                Your results for  {fuelType.description}  were not automatically flagged but you have elected to explore potential data
                reliability issues anyway.  It looks like your reported average expenditures for your
                &nbsp;{fuelType.description}&nbsp;households are less than expected, let's explore some reasons why
                you might have that result.
                <br/><br/>
                <Assessment1QuestionsUnderReporting state={state}  fuelType={fuelType}  showDontKnowNote={true} />
                {
                  (fuelType.IncludingEnergyUseChargesFlag !== null
                    && fuelType.IncludingEnergyDeliveryChargesFlag !== null
                    && fuelType.IncludingComplete12MonthFlag !== null
                    && fuelType.IndicatingLessThan12MonthFlag !== null
                    && fuelType.ReportingAfterDiscountsFlag !== null)
                  &&
                    <div>
                        Now that you have checked for reasons that the average expenditures might be too low it is useful to check
                        ways in which vendors might be over-reporting for some clients. Here are some important issues.
                        <br/><br/>
                        <Assessment1QuestionsOverReporting state={state}  fuelType={fuelType}  showDontKnowNote={false}/>
                    </div>
                }
            </div>
        }



        {/*OverMax*/}
        {(fuelType.percentOfSedsStatus === Assessment1FuelStatusEnum.OverMax)
            &&
            <div>
                <br/>
                Since the reported average expenditures for your  {fuelType.description}  households are greater than expected, lets explore
                some reasons why you might have that result.
                <br/><br/>

                <Assessment1QuestionsOverReporting state={state}  fuelType={fuelType}  showDontKnowNote={true}/>
                {
                  (fuelType.IncludingEnergyOptionalChargesFlag !== null
                    && fuelType.Including12MonthOnlyFlag !== null
                    && fuelType.CheckOutliersFlag !== null
                    && fuelType.IncludeOnlyAmountBilledFlag !== null)
                  &&
                    <div>
                        Now that you have checked for reasons that the average expenditures might be 
                        too high it is useful to check ways in which the vendor might be underreporting 
                        for some clients. Here are some important issues.
                        <br/><br/>
                        <Assessment1QuestionsUnderReporting state={state}  fuelType={fuelType}  showDontKnowNote={false}/>
                    </div>
                }
            </div>
        }

        {/*InRangeNoIssues, viewAnyway, averageExpenseGreaterThanSeds*/}
        {(fuelType.percentOfSedsStatus === Assessment1FuelStatusEnum.InRangeNoIssues
            && fuelType.viewAnyway === true
            && fuelType.averageExpenseGreaterThanSeds === true)
            &&
            <div>
                <br/>
                Your results for  {fuelType.description}  were not automatically flagged but you have elected to explore potential data
                reliability issues anyway.  It looks like your reported average expenditures for your   {fuelType.description}&nbsp; 
                households are greater than expected, let's explore some reasons why you might have that result.
                <br/><br/>
                <Assessment1QuestionsOverReporting state={state}  fuelType={fuelType}  showDontKnowNote={true}/>
                {
                  (fuelType.IncludingEnergyOptionalChargesFlag !== null
                    && fuelType.Including12MonthOnlyFlag !== null
                    && fuelType.CheckOutliersFlag !== null
                    && fuelType.IncludeOnlyAmountBilledFlag !== null)
                  &&
                    <div>
                        Now that you have checked for reasons that the average expenditures might be 
                        too high it is useful to check ways in which the vendor might be underreporting 
                        for some clients. Here are some important issues.
                        <br/><br/>
                        <Assessment1QuestionsUnderReporting state={state}  fuelType={fuelType}  showDontKnowNote={false}/>
                    </div>
                }
            </div>
        }

        

    </div>
);

export default Assessment1Questions;
